export interface Collaborator {
  instanceId: string;
  firstName: string;
  lastName: string;
  email: string;
  isActive: boolean;
  profileId: string;
  profileLabel: string | null;
}

export const EmptyCollaborator: Collaborator = {
  instanceId: '',
  firstName: '',
  lastName: '',
  email: '',
  isActive: true,
  profileId: '',
  profileLabel: null,
};
